import request from "@utils/request";

/**
 * 首页
 * @returns {*}
 */
export function getHomeData() {
  return request.get("index", {}, { login: false });
}
 

/**
 * 文章 轮播列表
 * @returns {*}
 */
export function getArticleBanner(banner) {
  return request.get("/article/detail", banner, { login: false });
}


/**
 * 文章分类列表
 * @returns {*}
 */
export function getArticleCategory(getart) {
  return request.get("/article/category/list", {getart}, { login: false });
}

/**
 * 文章 热门列表
 * @returns {*}
 */
export function getArticleHotList(getart) {
  return request.get("/article/list", getart, { login: false });
}
 
 
 export function hotList(getart) {
   return request.get("/article/hot/list", getart, { login: false });
 }

/**
 * 文章列表
 * @returns {*}
 */
export function getArticleList(q, cid) {
  return request.get("/article/list/" + cid, q, { login: false });
}



/**
 * 分享
 * @returns {*}
 */
export function getShare() {
  return request.get("/share", {}, { login: false });
}

/**
 * 文章详情
 * @returns {*}
 */
export function getArticleDetails(id) {
  return request.get("/article/details",id, { login: false });
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig() {
  return request.get(
    "/wechat/config",
    { url: document.location.href },
    { login: false }
  );
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function wechatAuth(code, spread, login_type) {
  return request.get(
    "/wechat/auth",
    { code, spread, login_type },
    { login: false }
  );
}
/**
 * 获取快递公司
 * @returns {*}
 */
export function getLogistics() {
  return request.get("/logistics", {}, { login: false });
}

/**
 * 获取登陆logo
 * @returns {*}
 */
export function getLogo(type) {
  return request.get("/wechat/get_logo", { type: type }, { login: false });
}


// 验证码
export function yanZheng(type) {
  return request.get("/user/captcha", { type: type }, { login: false });
}

/**
 * 获取图片base64
 * @retins {*}
 * */
export function imageBase64(image, code) {
  return request.post(
    "/image_base64",
    { image: image, code: code },
    { login: false }
  );
}

/**
 * 获取关注海报
 * @returns {*}
 */
export function follow() {
  return request.get("/wechat/follow", {}, { login: false });
}

/**
 * 视频列表
 * @returns {*}
 */
export function getVideoList(q) {
  return request.get("/video",q, { login: false });
}
/**
 * 视频详情
 * @returns {*}
 */
export function getVideoDetail(q) {
  return request.get("/video_one",q, { login: false });
}
/**
 * 增加金币
 * @returns {*}
 */
export function getVideoMoney(q) {
  return request.get("/video_money",q, { login: false });
}
/**
 * 
 * @returns {*}
 */
export function getUser(q) {
  return request.get("/user",q, { login: true });
}